import _ from 'lodash'

/**
 * Finds the {departmentId} the {itemGroup} {choices} belong to.
 * If there is more than one department it will return {null}
 */
export function getItemGroupSingleDepartmentId (itemGroup) {
  let singleDepId = null

  for (const { departmentId } of _.get(itemGroup, 'choices', [])) {
    if (!singleDepId) {
      singleDepId = departmentId
    } else if (departmentId !== singleDepId) {
      return null
    }
  }

  return singleDepId
}
